//src/app/features/questionnaires/create/PrepareQuestionnaire/preview.tsx
import PreviewTable from 'app/features/questionnaires/components/PreviewTable';
import { countries, countriesLookUp } from 'countries';
import { useSelector } from 'react-redux';
import { statesLookup } from 'states';
import PreviewExpandable from '../../components/PreviewExpandable';
import PreviewSummary from '../../edit/TaxQuestionnaire/Summary/preview';
import { selectPrepareQuestionnaire } from './slice';
import { useFields } from './useFields';

export interface IPreviewPrepareQuestionnaireProps {}

export default function PreviewPrepareQuestionnaire(
  props: IPreviewPrepareQuestionnaireProps,
) {
  return (
    <PreviewExpandable title="Situation Analysis">
      <PreviewSummary />
    </PreviewExpandable>
  );
}
